import { render, staticRenderFns } from "./TabWebinars.vue?vue&type=template&id=5eb67578&"
import script from "./TabWebinars.vue?vue&type=script&lang=js&"
export * from "./TabWebinars.vue?vue&type=script&lang=js&"
import style0 from "./TabWebinars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabWebinars.vue"
export default component.exports